import HandleResponses from '@common/utils/handleResponses';

import axios from '../../../axios';

const actions = {
  async getDeliveries({ commit }, { params }) {
    try {
      const result = await axios.get('/deliveries', { params });
      if (result && !result.error) {
        if (result.data && result.data.length) {
          commit('APPEND_DELIVERIES', result.data);
        } else {
          commit('PAGINATION_CHECK', true);
        }
      }
      return result;
    } catch (err) {
      throw err;
    }
  },
  async getRequests({ commit }, { params }) {
    try {
      const result = await axios.get('planning/requests', { params });
      if (result && !result.error) {
        if (result.data && result.data.length) {
          commit('APPEND_REQUESTS', result.data);
        } else {
          commit('PAGINATION_CHECK', true);
        }
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getDeliveriesCount({ commit }, { params }) {
    try {
      const result = await axios.get('/deliveries_count', { params });
      return result;
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
